'use client';
import { Config } from 'constants/config';
import { usePageContext } from 'hooks/context';

/**
 * Get the server or client configuration
 *
 * @deprecated Use `getServerContext().config` instead
 */
export function useConfig(): Config {
  return usePageContext().config;
}
